export default __webpack_public_path__ + "static/media/fileWaterMarks.3d0712e7.svg";